import { render } from "./TicketsReservationEdit.vue?vue&type=template&id=104484db&lang=pug"
const script = {}

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__